@import (reference) '../../../../../../../constants/spacing.module.less';

.promotional-price {
  width: 100%;
}

.original-price-row {
  align-items: center;
}

.strikethrough {
  text-decoration: line-through;
  color: var(--gray-74818d);
  font-size: 14px;
}

.discounted-price {
  color: var(--gray-212c36);
  margin: 0;
}
